import LicensingImg from "public/vdi/spla-byol-licensing.png";
import {ListWithLabel} from "@/components/list";

export const LICENSING_CONSTANTS = {
  title: "SPLA and BYOL Licensing Options",
  description:
    "Onemind supports flexible licensing models to align with your organization's existing software investments or vendor preferences.",
  children: (
    <ListWithLabel
      key="list"
      points={[
        {
          label: "Bring Your Own License (BYOL)",
          text: "Easily integrate your existing Microsoft or third-party licenses into our hosted VDI infrastructure—minimizing costs and preserving software entitlements.",
        },
        {
          label: "Microsoft SPLA Model",
          text: "For customers without licenses, Onemind offers access through Microsoft’s SPLA (Service Provider License Agreement), enabling subscription-based access to Windows Server, RDS, and Office applications.",
        },
        {
          label: "Ideal for Hybrid Licensing Environments",
          text: "Whether migrating from an on-prem VDI setup or consolidating license management across clouds, our licensing flexibility supports smooth onboarding and compliance.",
        },
      ]}
    />
  ),
  conclusion:
    "With Onemind’s SPLA/BYOL-ready environment, enterprises gain full control over licensing while benefiting from our fully managed infrastructure and support.",
  image: LicensingImg,
};
